// extracted by mini-css-extract-plugin
module.exports = {"nav":"addUserPage_nav__1F-Ql"};